<template>
  <v-app>
    <!-- Main -->
    <template v-if="rootstore.init">
      <core-toolbar />
      <core-drawer />
      <core-view />
      <core-footer />
      <core-notification-snackbar />
      <core-login-register-dialog />
    </template>

    <!-- Loading Overlay -->
    <v-row v-else align="center" justify="center" class="v-overlay" style="position: absolute">
      <v-progress-circular indeterminate color="primary" />
    </v-row>
  </v-app>
</template>

<script>
import { useUserStore, useWwStore } from '@/store'

export default {
  data() {
    return {
      isInitialized: false,
      rootstore: useWwStore()
    }
  },

  mounted() {
    Promise.all([useUserStore().loadUser()]).then(() => {
      this.isInitialized = true
      //useRootStore.state.init = true

      if (!useUserStore().isSubscriber) {
        window.InvestingChannelQueue = window.InvestingChannelQueue || []
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', 'https://u5.investingchannel.com/static/uat.js')
        document.head.appendChild(externalScript)
        var page
        window.InvestingChannelQueue.push(function () {
          page = window.InvestingChannel.UAT.Run('eb033e36-f527-46c7-b805-92c1fb0f90cc')
        })
      } else {
        window.InvestingChannelQueue = window.InvestingChannelQueue || []
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', 'https://u5.investingchannel.com/static/uat.js')
        document.head.appendChild(externalScript)
        var ic_page
        window.InvestingChannelQueue.push(function () {
          ic_page = window.InvestingChannel.UAT.Run('85b226af-2348-429a-8838-8e22eea88d78', {
            show_no_ads: true
          })
        })
      }
    })
  }
}
</script>

<style lang="scss">
@use '@/assets/style/main';

#nprogress .bar {
  background: $primary;
}
.v-application a {
  color: #00a892;
}
.v-theme--light .v-list-item-title {
  color: #000;
}

.v-theme--dark .v-list-item-title {
  color: #fff;
}
</style>
